import { DateTime } from 'luxon'
import { retrievalLastDay } from './hostingLifecycle'

// The last day an ended server is kept, from its deletion_at (unix seconds).
export const vserverLastDay = (deletionAt: number | null | undefined, locale: string): string =>
  deletionAt ? retrievalLastDay(DateTime.fromSeconds(deletionAt).toISO() ?? '', locale) : ''

// Status → CSS-class mappings for the status enums surfaced in the VServer
// dashboard. Kept domain-scoped because the input vocabularies differ
// (VServer lifecycle, snapshot lifecycle, IP-pool status, guest-agent liveness).

export const vserverStatusClass = (status: string): string => {
  switch (status) {
    case 'active':
      return 'status-success'
    case 'stopped':
    case 'deprovisioned':
      return 'status-grey'
    case 'failed':
      return 'status-error'
    case 'suspended':
      return 'status-warning'
    case 'provisioning':
    case 'resizing':
    case 'reinstalling':
    case 'deprovisioning':
      return 'status-info'
    default:
      return 'status-grey'
  }
}

export const snapshotStatusClass = (status: string): string => {
  switch (status) {
    case 'active':
      return 'status-success'
    case 'creating':
      return 'status-info'
    case 'deleting':
      return 'status-warning'
    case 'failed':
      return 'status-error'
    default:
      return 'status-grey'
  }
}

// guest_agent is "running" | "stopped" | null (null = unknown / VM off).
export const guestAgentStatusClass = (status: string | null | undefined): string => {
  switch (status) {
    case 'running':
      return 'status-success'
    case 'stopped':
      return 'status-warning'
    default:
      return 'status-grey'
  }
}

export const ipPoolStatusClass = (status: string): string => {
  switch (status) {
    case 'available':
      return 'status-success'
    case 'allocated':
      return 'status-info'
    case 'reserved':
      return 'status-warning'
    default:
      return 'status-grey'
  }
}
